export const PAYROLL_KEYS = {
  all: ["payroll-settings"] as const,
  lists: () => [...PAYROLL_KEYS.all, "list"] as const,
  list: (filters: any) => [...PAYROLL_KEYS.lists(), { filters }] as const,
  details: () => [...PAYROLL_KEYS.all, "detail"] as const,
  detail: (id: string) => [...PAYROLL_KEYS.details(), id] as const,
  byKey: (key: string) => [...PAYROLL_KEYS.all, "key", key] as const,
  settingsMap: () => [...PAYROLL_KEYS.all, "map"] as const,
};
